import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=97e96a6c&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=97e96a6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e96a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e96a6c')) {
      api.createRecord('97e96a6c', component.options)
    } else {
      api.reload('97e96a6c', component.options)
    }
    module.hot.accept("./EditForm.vue?vue&type=template&id=97e96a6c&scoped=true", function () {
      api.rerender('97e96a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyPrice/GasPrice/EditForm.vue"
export default component.exports